<glxy-form-field [bottomSpacing]="bottomSpacing">
  @if (placeholder) {
    <glxy-label>{{ placeholder }}</glxy-label>
  }
  <input
    [placeholder]="placeholder"
    [formControl]="control"
    [required]="required"
    [type]="type"
    [name]="name"
    matInput
  />
  @if (tooltip) {
    <glxy-hint align="left" [matTooltip]="tooltip">
      <a (click)="(null)" class="link">
        {{ 'FRONTEND.FORMS.INPUT.WHATS_THIS' | translate }}
      </a>
    </glxy-hint>
  }

  @if (control.errors) {
    <glxy-error>{{ errorOutput(control) }}</glxy-error>
  }
</glxy-form-field>
